/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
(() => {
  const allBrandsHolder = document.querySelector(
    ".mega-menu__all-brands-hidden"
  );

  const brandsColumn = document.querySelector(".mega-menu__brands-columns");

  const allBrands = [...allBrandsHolder.children];

  const alphabet =
    "#,A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z".split(",");

  const brandsObject = {};

  let brandsIndex = 0;
  alphabet.forEach((letter) => {
    const currentRow = [];
    for (brandsIndex; brandsIndex < allBrands.length; brandsIndex += 1) {
      allBrands[brandsIndex].classList.add(
        "body-light",
        "text-black",
        "default-link"
      );
      const firstLetter = Array.from(
        allBrands[brandsIndex].innerText
      )[0].toUpperCase();
      if (letter === "#") {
        if (/[a-zA-Z]/.test(firstLetter)) {
          break;
        } else {
          currentRow.push(allBrands[brandsIndex]);
          continue;
        }
      }

      if (letter === "Z") {
        currentRow.push(allBrands[brandsIndex]);
        continue;
      }

      if (firstLetter !== letter) {
        break;
      } else {
        currentRow.push(allBrands[brandsIndex]);
      }
    }
    brandsObject[letter] = currentRow;
  });

  function putIntoPlace(searchKey) {
    while (brandsColumn.firstChild) {
      brandsColumn.removeChild(brandsColumn.firstChild);
    }
    let filled = 0;
    let found = false;
    for (const [key, brands] of Object.entries(brandsObject)) {
      if (!found) {
        if (key === searchKey) {
          found = true;
        } else {
          continue;
        }
      }

      if (brands.length === 0) {
        continue;
      }
      if (filled > 20) {
        break;
      }
      if (filled === 6 || filled === 13) {
        brandsColumn.append(document.createElement("span"));
        filled += 1;
      }

      if (filled === 20) {
        return;
      }
      const head = document.createElement("span");
      head.innerText = key;
      head.classList.add("body-black", "text-black");
      brandsColumn.append(head);
      filled += 1;
      for (let index = 0; index < brands.length; index += 1) {
        brandsColumn.append(brands[index].cloneNode(true));
        filled += 1;
        if (filled === 21) {
          return;
        }
      }
    }
  }
  putIntoPlace("#");

  const sortBtns = document.querySelectorAll(".mega-menu__sort-btn");

  let currentActive = sortBtns[0];

  sortBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      brandsColumn.classList.add("transition");
      setTimeout(() => {
        currentActive.classList.remove("active");
        putIntoPlace(btn.innerText);
        currentActive = btn;
        btn.classList.add("active");
        brandsColumn.classList.remove("transition");
      }, 200);
    });
  });
})();
